import { NavLink } from "react-router-dom";

import Card from "shared/Card";

import IconArrowRight from "assets/icons/iconArrowRight.svg";

import copy from "api/copy.json";

const ReferralLink = () => {
  return (
    <NavLink to="/referrals">
      <Card className="mb-3 gkit-bg-pink">

        <div class="mb-2 d-flex justify-content-between align-items-center">
          <h3 className="gkit-h3 mb-0">{copy.sidebar.referral.title}</h3>
          <img alt="" src={IconArrowRight} />
        </div>

        <p className="gkit-p-15 gkit-sm-p-13 m-0">{copy.sidebar.referral.subtitle}</p>

      </Card>
    </NavLink>
  );
};

export default ReferralLink;
